import { Link } from "react-router-dom";
import { Instagram, Youtube, MapPin, Clock, Phone } from "lucide-react";
import { WordMark } from "@/components/Logo";
import { GreekKeyDivider } from "@/components/GreekKeyDivider";

const INSTAGRAM_URL = "https://www.instagram.com/elysiumtrainingclub";

export function Footer() {
  return (
    <footer className="bg-surface border-t border-line safe-bottom" data-testid="main-footer">
      <GreekKeyDivider />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 sm:gap-8">
        <div>
          <div className="flex items-center gap-2.5 mb-4">
            <WordMark className="h-16 w-16" />
          </div>
          <p className="text-smoke text-sm leading-relaxed max-w-xs">
            The afterlife for heroes. A Functional Fitness gym built for athletes who train like every rep counts.
          </p>
          <div className="flex items-center gap-4 mt-5">
            <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="text-smoke hover:text-gold transition-colors" data-testid="footer-instagram-link">
              <Instagram className="h-5 w-5" />
            </a>
            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="text-smoke hover:text-gold transition-colors" data-testid="footer-youtube-link">
              <Youtube className="h-5 w-5" />
            </a>
          </div>
        </div>

        <div>
          <h4 className="font-anton uppercase text-cream text-sm tracking-widest mb-4">Explore</h4>
          <ul className="space-y-3 text-sm text-smoke">
            <li><Link to="/programs" className="hover:text-gold transition-colors" data-testid="footer-link-programs">Programs</Link></li>
            <li><Link to="/schedule" className="hover:text-gold transition-colors" data-testid="footer-link-schedule">Schedule</Link></li>
            <li><Link to="/membership" className="hover:text-gold transition-colors" data-testid="footer-link-membership">Membership</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-anton uppercase text-cream text-sm tracking-widest mb-4">Community</h4>
          <ul className="space-y-3 text-sm text-smoke">
            <li><Link to="/contact" className="hover:text-gold transition-colors" data-testid="footer-link-contact">Contact</Link></li>
            <li><Link to="/login" className="hover:text-gold transition-colors" data-testid="footer-link-login">Member Login</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-anton uppercase text-cream text-sm tracking-widest mb-4">Visit</h4>
          <ul className="space-y-3 text-sm text-smoke">
            <li className="flex items-start gap-2"><MapPin className="h-4 w-4 mt-0.5 text-gold shrink-0" /> Unit 6, SA1 Business Park, Swansea, SA1 8DB</li>
            <li className="flex items-start gap-2"><Clock className="h-4 w-4 mt-0.5 text-gold shrink-0" /> Open 7 days — see schedule for hours</li>
            <li className="flex items-start gap-2"><Phone className="h-4 w-4 mt-0.5 text-gold shrink-0" /> 07305 864246</li>
            <li className="flex items-start gap-2">
              <Instagram className="h-4 w-4 mt-0.5 text-gold shrink-0" />
              <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors" data-testid="footer-instagram-handle">
                @elysiumtrainingclub
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-line py-6 px-4 text-center text-xs text-smoke/70">
        © {new Date().getFullYear()} Elysium Training Club. All rights reserved.
      </div>
    </footer>
  );
}
